export const showUrlWindow = (url: string): void => {
  const mediaWindow = window.open(url, '', `fullscreen=1,scrollbars=1,resizable=1`)

  if (mediaWindow) {
    mediaWindow.document.title = url
    mediaWindow.document.open()
    mediaWindow.document.location.href = url
    mediaWindow.document.close()
  }
}
